import { NgModule } from '@angular/core';
import { moduleConfigFunc, TnxSharedModule } from 'tnx-shared';
import { GroupModule } from 'tnx-admin-service/group';
import { KhaoSatClientComponent } from './khao-sat-client.component';
import { KhaoSatClientRoutes } from './khao-sat-client.routing';

export function declaration() {
    return [KhaoSatClientComponent];
}

@NgModule({
    imports: [
        TnxSharedModule,
        GroupModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class KhaoSatClientModule {
    static forRoot(config?: any): any {
        return {
            ngModule: TnxSharedModule,
            providers: [
                {
                    provide: moduleConfigFunc,
                    useValue: config
                }
            ]
        };
    }
}

@NgModule({
    imports: [KhaoSatClientModule, KhaoSatClientRoutes],
    exports: [KhaoSatClientModule]
})
export class KhaoSatClientWithRouteModule {
    static forRoot(config?: any): any {
        return {
            ngModule: TnxSharedModule,
            providers: [
                {
                    provide: moduleConfigFunc,
                    useValue: config
                }
            ]
        };
    }
}
